import PayModal from './PayModal';
import Table    from './Table'   ;

type Props = {
  PayModal: typeof PayModal;
  Table   : typeof Table   ;
}

const FinancialReportCompanyComponents: Props = {
  PayModal,
  Table   ,
}

export default FinancialReportCompanyComponents;
